import React, { PropsWithChildren } from "react";

import { QueryAwait, defaultQueryClient } from "@steto-care/steto-query";
import { QueryClientProvider } from "@tanstack/react-query";

import { CriticalErrorPage } from "@/uiKit/pages/CriticalErrorPage.tsx";
import { LoadingPage } from "@/uiKit/pages/LoadingPage.tsx";

export const QueriesWrapper: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <QueryClientProvider client={defaultQueryClient}>
      <QueryAwait errorFallback={CriticalErrorPage} pendingFallback={LoadingPage}>
        {children}
      </QueryAwait>
    </QueryClientProvider>
  );
};
